<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!--内容-->
    <div class="content-wrap">
      <div class="par-box">
        <h1>全国区域招商请拨打 18012783327 电话详细咨询</h1>
        <div class="erweima">
          <p>微信扫码咨询 - 张老师</p>
          <img src="../../assets/images/zhangzy-erweima.png">
        </div>
      </div>
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
.banner-info {
  width: 100%;
  height: 200px;
  background: url('../../assets/images/banner002.png');
  background-size: 100% 100%;
}

.content-wrap {
  width: 95%;
  margin: 0 auto;
}

/*内容*/
.par-box {
  height: 550px;
  background: #ececec;
  border-radius: 10px;
  border-bottom: 10px solid #e58111;
  margin: 40px 0;
  padding: 20px;
}
.par-box h1{
  font-size: 32px;
  line-height: 50px;
}
.par-box p {
  margin-top: 25px;
  font-size: 32px;
  line-height: 55px;
}
.erweima{
  text-align: center;
}
.par-box img {
  margin-top: 15px;
  width: 300px;
  height: 300px;
}


</style>



// WEBPACK FOOTER //
// src/pages/admissions/consultPage.vue